import { render, staticRenderFns } from "./ContactHistory.html?vue&type=template&id=5047f84f&external"
import script from "./ContactHistory.vue?vue&type=script&lang=js"
export * from "./ContactHistory.vue?vue&type=script&lang=js"
import style0 from "./ContactHistory.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports